var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcaseHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29382",
    "data-name": "Group 29382",
    transform: "translate(-8 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_9_",
    "data-name": "svgexport-17 (9)",
    transform: "translate(24.92 268.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28911",
    "data-name": "Group 28911",
    transform: "translate(1.745 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49889",
    "data-name": "Path 49889",
    d: "M16.035,2H11.672a1.309,1.309,0,0,0-1.309,1.309V5.054a.436.436,0,0,0,.436.436h6.108a.436.436,0,0,0,.436-.436V3.309A1.309,1.309,0,0,0,16.035,2Zm.436,2.618H11.236V3.309a.436.436,0,0,1,.436-.436h4.363a.436.436,0,0,1,.436.436ZM8.181,18.579H6.436A.436.436,0,0,0,6,19.016v1.309a.873.873,0,0,0,.873.873h.873a.873.873,0,0,0,.873-.873V19.016A.436.436,0,0,0,8.181,18.579Zm13.089,0H19.525a.436.436,0,0,0-.436.436v1.309a.873.873,0,0,0,.873.873h.873a.873.873,0,0,0,.873-.873V19.016A.436.436,0,0,0,21.27,18.579Z",
    transform: "translate(-6 -2)",
    fill: "#4d5258"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8459",
    "data-name": "Rectangle 8459",
    width: 19.197,
    height: 14.834,
    rx: 5,
    transform: "translate(0 2.618)",
    fill: "#b35c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49890",
    "data-name": "Path 49890",
    d: "M20.953,13.6l-.436-1.309a.436.436,0,0,0-.554-.275l-2.618.873a.436.436,0,0,0-.275.554l.436,1.309a.436.436,0,0,0,.393.3.545.545,0,0,0,.14-.022l2.618-.873a.436.436,0,0,0,.3-.554Z",
    transform: "translate(-10.482 -7.635)",
    fill: "#bee1f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 2.181,
    cy: 2.182,
    rx: 2.181,
    ry: 2.182,
    transform: "translate(6.544 10.908)",
    fill: "#bee1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49891",
    "data-name": "Path 49891",
    d: "M39.25,29.357l-.633-.319v-.6A.436.436,0,0,0,38.181,28H36.436a.433.433,0,0,0-.423.541l.436,1.745a.436.436,0,0,0,.423.332h2.181a.436.436,0,0,0,.436-.436v-.436A.436.436,0,0,0,39.25,29.357Z",
    transform: "translate(-21.165 -16.656)",
    fill: "#a30000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8460",
    "data-name": "Rectangle 8460",
    width: 2.618,
    height: 2.618,
    rx: 1,
    transform: "translate(1.309 6.545)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49892",
    "data-name": "Path 49892",
    d: "M34.307,14.1,32.1,12.792l-1.745-.873-1.287-.873a.436.436,0,0,0-.663.257l-.436,1.745a.436.436,0,0,0,.161.436l1.745,1.309.065.039,2.618,1.309a.406.406,0,0,0,.218.079.436.436,0,0,0,.31-.127l1.309-1.309a.44.44,0,0,0-.087-.685Z",
    transform: "translate(-16.633 -7.059)",
    fill: "#f0ab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49893",
    "data-name": "Path 49893",
    d: "M7.512,31.991l-2.181.436a.436.436,0,0,0-.349.541l.436,1.745a.436.436,0,0,0,.541.332L7.7,34.609a.436.436,0,0,0,.332-.436V32.428a.453.453,0,0,0-.524-.436Z",
    transform: "translate(-3.673 -18.902)",
    fill: "#7dc3e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8461",
    "data-name": "Rectangle 8461",
    width: 4.799,
    height: 2.182,
    rx: 1,
    transform: "translate(9.162 8.29)",
    fill: "#7dc3e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49894",
    "data-name": "Path 49894",
    d: "M10,8h2.618V22.834H10Zm9.6,0h2.618V22.834H19.6Z",
    transform: "translate(-6.51 -5.382)",
    fill: "#773d00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcaseHighlighted);
export default __webpack_public_path__ + "static/media/SuitcaseHighlighted.8bf06f5bbf49ff1d0b83459f85a5f741.svg";
export { ForwardRef as ReactComponent };